import type { RecordingCaptureMetadata } from "@/services/recording-db"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export type CreateSessionResponse = {
  id: string
  guid: string
  status: string
  content_type: string
}

export async function createLiveRecordingSession(
  ctx: ApiContext,
  meetingId: string,
  contentType: string
): Promise<CreateSessionResponse> {
  return apiContextFetch(ctx, `meetings/${meetingId}/live_recording_sessions`, {
    method: "POST",
    signal: AbortSignal.timeout(30_000),
    body: JSON.stringify({ content_type: contentType, protocol_version: 2 }),
  })
}

export type PresignResponse = {
  url: string
  key: string
  final: boolean
}

export async function presignChunk(
  ctx: ApiContext,
  meetingId: string,
  sessionId: string,
  sequence: number,
  contentType: string
): Promise<PresignResponse> {
  return apiContextFetch(ctx, `meetings/${meetingId}/live_recording_sessions/${sessionId}/chunks/presign`, {
    method: "POST",
    signal: AbortSignal.timeout(30_000),
    body: JSON.stringify({
      sequence,
      content_type: contentType,
    }),
  })
}

export async function confirmChunk(
  ctx: ApiContext,
  meetingId: string,
  sessionId: string,
  sequence: number,
  key: string
): Promise<void> {
  await apiContextFetch(ctx, `meetings/${meetingId}/live_recording_sessions/${sessionId}/chunks/confirm`, {
    method: "POST",
    signal: AbortSignal.timeout(30_000),
    body: JSON.stringify({ sequence, key }),
  })
}

export type FinalizeResponse = {
  session_id: string
  status: string
}

export async function abandonSession(ctx: ApiContext, meetingId: string, sessionId: string): Promise<void> {
  await apiContextFetch(ctx, `meetings/${meetingId}/live_recording_sessions/${sessionId}/chunks/abandon`, {
    method: "POST",
    signal: AbortSignal.timeout(30_000),
  })
}

export async function finalizeChunks(
  ctx: ApiContext,
  meetingId: string,
  sessionId: string,
  totalChunks: number,
  capture?: RecordingCaptureMetadata
): Promise<FinalizeResponse> {
  return apiContextFetch(ctx, `meetings/${meetingId}/live_recording_sessions/${sessionId}/chunks/finalize`, {
    method: "POST",
    signal: AbortSignal.timeout(30_000),
    body: JSON.stringify({ total_chunks: totalChunks, capture }),
  })
}
